import { render } from "./MarketInquiryForm.vue?vue&type=template&id=e16912d4&scoped=true&ts=true"
import script from "./MarketInquiryForm.vue?vue&type=script&lang=ts"
export * from "./MarketInquiryForm.vue?vue&type=script&lang=ts"

import "./MarketInquiryForm.vue?vue&type=style&index=0&id=e16912d4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e16912d4"]])

export default __exports__